// extracted by mini-css-extract-plugin
export default {"how-to-section":"how-to-section_how-to-section__+7DDC","svg-container":"how-to-section_svg-container__JTfyz"};